import React, { useState, useEffect } from "react";
import { Input, Checkbox } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import GetImage from "../../../components/getimage/Getimage";
import TooltipButton from "../../../components/tooltip/Popover";

export default function Step3({
  defaultattendee,
  formData,
  setFormData,
  attendessarr,
  userid
}) {
  const [employees, setEmployees] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [selectedMap, setSelectedMap] = useState({});
  const [search, setSearch] = useState("");

  // 🔹 INIT
  useEffect(() => {
    if (!attendessarr) return;

    const normalized = attendessarr.map((emp) => ({
      value: emp?.empid,
      label: `${emp?.firstname} ${emp?.lastname}`
    }));

    setEmployees(normalized);
    setFiltered(normalized);

    let selectedIds = [];

    if (formData.attendees) {
      selectedIds = formData.attendees.split(",");
    } else {
      if (!defaultattendee) selectedIds = [String(userid)];
      else selectedIds = [String(userid), String(defaultattendee)];
    }

    const map = {};
    selectedIds.forEach((id) => (map[id] = true));

    setSelectedMap(map);

    setFormData((prev) => ({
      ...prev,
      attendees: selectedIds.join(",")
    }));
  }, [attendessarr, userid]);

  // 🔹 SEARCH
  const storeSearch = (e) => {
    const value = e.target.value;
    setSearch(value);

    if (!value) {
      setFiltered(employees);
    } else {
      const f = employees.filter((emp) =>
        emp.label.toLowerCase().includes(value.toLowerCase())
      );
      setFiltered(f);
    }
  };

 
 const toggleEmployee = (emp) => {
  setSelectedMap((prev) => ({
    ...prev,
    [emp.value]: !prev[emp.value]
  }));

  setFormData((prev) => {
    let arr = prev.attendees ? prev.attendees.split(",") : [];
    arr = arr.filter((x) => x);

    const exists = arr.includes(String(emp.value));

    if (exists) {
      arr = arr.filter((id) => id !== String(emp.value));
    } else {
      arr = [...arr, String(emp.value)]; // ✅ maintain selection order
    }

    return {
      ...prev,
      attendees: arr.join(",")
    };
  });
};

  const selectAll = (e) => {
    const checked = e.target.checked;

    if (checked) {
      const ids = filtered.map((emp) => String(emp.value));

      const map = {};
      ids.forEach((id) => (map[id] = true));

      setSelectedMap((prev) => ({ ...prev, ...map }));

      setFormData((prev) => {
        let arr = prev.attendees ? prev.attendees.split(",") : [];

        arr = [
          ...ids,
          ...arr.filter((id) => !ids.includes(id))
        ];

        return {
          ...prev,
          attendees: arr.join(",")
        };
      });
    } else {
      setSelectedMap({});
      setFormData((prev) => ({
        ...prev,
        attendees: ""
      }));
    }
  };

  const attendeeOrder = formData?.attendees
    ? formData.attendees.split(",")
    : [];

  const sortedFiltered = [
    ...attendeeOrder.map((id) =>
      filtered.find((emp) => String(emp.value) === id)
    ).filter(Boolean),

    ...filtered.filter((emp) => !selectedMap[emp.value])
  ];

  const empIds = attendeeOrder;

  const circle = (color, ml = 0, z = 1) => ({
    width: "34px",
    height: "34px",
    borderRadius: "50%",
    backgroundColor: color,
    border: "2px solid white",
    marginLeft: ml,
    zIndex: z,
    overflow: "hidden"
  });

  return (
    <div className="container-fluid" style={{ overflow: "hidden" }}>
      <div className="row">
        <p className="selectmeetingtime">
          Select Meeting Attendees <TooltipButton fieldName={"MeetingAttendees"} />
        </p>

        <div className="col-12">

          {/* HEADER */}
          <div className="row mb-2">
            <div className="col-4">
              <Input
                placeholder="Search"
                allowClear
                value={search}
                onChange={storeSearch}
                prefix={<SearchOutlined />}
              />
            </div>

            <div className="col-4 d-flex justify-content-center align-items-center">
              <Checkbox
                onChange={selectAll}
                checked={
                  filtered.length > 0 &&
                  filtered.every((emp) => selectedMap[emp.value])
                }
              >
                Select All
              </Checkbox>
            </div>

        
            <div className="col-4 d-flex justify-content-center">
              <div style={{ display: "flex", alignItems: "center" }}>
                {empIds[0] && (
                  <div style={circle("#60a5fa")}>
                    <GetImage imgID={empIds[0]} width="100%" height="100%" />
                  </div>
                )}

                {empIds[1] && (
                  <div style={circle("#f87171", "-11px", 2)}>
                    <GetImage imgID={empIds[1]} width="100%" height="100%" />
                  </div>
                )}

                {empIds.length > 2 && (
                  <div
                    style={{
                      ...circle("#9ca3af", "-11px", 3),
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "10px",
                      color: "#fff"
                    }}
                  >
                    +{empIds.length - 2}
                  </div>
                )}
              </div>
            </div>
          </div>

          
          <div
            style={{
              maxHeight: "300px",
              overflowY: "auto",
              overflowX: "hidden",
              paddingBottom: "15vh"
            }}
          >
            <div className="row">
              {sortedFiltered.map((emp) => {
                const isChecked = !!selectedMap[emp.value];

                return (
                  <div className="col-4 mb-2" key={emp.value}>
                    <div
                      className="d-flex align-items-center p-2"
                      style={{
                        cursor: "pointer",
                        border: "1px solid #eee",
                        borderRadius: "6px",
                        background: isChecked ? "#f0f8ff" : ""
                      }}
                      onClick={() => toggleEmployee(emp)}
                    >
                      <Checkbox checked={isChecked} style={{ marginRight: 6 }} />

                      <GetImage
                        imgID={emp.value}
                        width="30px"
                        height="30px"
                        redirect={false}
                      />

                      <span
                        style={{
                          fontSize: "clamp(12px, 1vw, 14px)",
                          marginLeft: "6px"
                        }}
                      >
                        {emp.label}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}